class ProductCardSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.swiperId = null;
    this.isDesktop = false;
    this.desktopWidth = 1025;
    this.slideSpeed = 500;
    this.observerIntersection = null;
    this.cardIndex = 0;
  }

  connectedCallback() {
    this.swiperId = this.getAttribute('data-swiper-id');
    this.slideSpeed = this.getAttribute('data-swiper-speed');
    this.cardIndex = this.getAttribute('data-card-index');

    // NEW: Check if this specific instance is above the fold
    const isEager = this.getAttribute('data-eager-load') === 'true';

    if (isEager) {
      // Initialize immediately, skipping the observer delay
      if (this.swiperId) {
        this.initProductBlockSlider();
      }
    } else {
      this.observerIntersection = new IntersectionObserver(
        this.observationCallback.bind(this),
        {
          root: null,
          rootMargin: '0px',
          threshold: 1,
        }
      );

      this.observerIntersection.observe(this);
    }
  }

  observationCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.swiperId) {
          this.initProductBlockSlider();
        }
        observer.unobserve(entry.target);
      }
    });
  }

  disconnectedCallback() {
    this.destroyProductBlockSlider();

    if (this.observerIntersection) {
      this.observerIntersection.disconnect();
    }
  }

  initProductBlockSlider() {
    const productCarouselId = document.querySelector(`#${this.swiperId}`);

    if (!productCarouselId) {
      return null;
    }

    this.swiperInstance = new Swiper(productCarouselId, {
      speed: this.slideSpeed,
      spaceBetween: 0,
      loop: false,
      slidesPerView: 1,
      centeredSlides: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      enabled: true,
      breakpoints: {
        [this.desktopWidth]: {
          enabled: false,
        },
      },
      on: {
        init: (e) => {
          const isLocked = e.isLocked;

          if (isLocked || this.cardIndex > 1) {
            return null;
          }

          const wrapperEl = e.slidesEl;
          wrapperEl.classList.add('animation-swipe-slide');

          wrapperEl.addEventListener('animationend', () => {
            wrapperEl.classList.remove('animation-swipe-slide');
          });
        },
      },
    });
  }

  destroyProductBlockSlider() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');
          this.swiperInstance = null;
          return;
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);
        this.swiperInstance = null;
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }
}

customElements.define('product-card-swiper-controller', ProductCardSwiper);
